export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "bundle.3a940d51da2dafd757ae.worker.js");
}
